import Hero from './Hero';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import defaultProps from 'recompose/defaultProps';
import { withModel } from '../../data-providers/model';
import { localiseUrl } from 'src/common/utils/format-localised-url';

const enhance = compose(
  withModel,
  defaultProps({
    contentColor: 'grey-dark',
    ctaColor: 'grey-dark',
  }),
  mapProps(props => ({
    ...props.primary,
    ctaLink: localiseUrl(props.model.countryModel, props.primary.ctaLink),
  })),
);

export default enhance(Hero);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Hero/index.js